import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";
import NotificationRequest from "../../interfaces/risk-analysis/NotificationRequest";
import RiskAnalysisResponse from "../../interfaces/risk-analysis/RiskAnalysisResponse";

const EXCESSIVE_ACTIVITY_API_URL =
  process.env.REACT_APP_EXCESSIVE_ACTIVITY_API_BASE_URL;

const sendNotification = (notificationRequest: NotificationRequest) => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }
  return request({
    method: "POST",
    url: EXCESSIVE_ACTIVITY_API_URL + "/excessive-activity/notification",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: notificationRequest,
  });
};

const getExcessiveActivity = (startDate?: Date, endDate?: Date) => {
  const token = getOktaAccessToken();
  if (!token) {
    return Promise.reject("Missing Token");
  }

  let startDateParam, endDateParam;
  //More weird date logic because javascript is dumb
  if (startDate) {
    startDateParam =
      startDate.getFullYear() +
      "-" +
      ("0" + (startDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + startDate.getDate()).slice(-2);
  }
  if (endDate) {
    endDateParam =
      endDate.getFullYear() +
      "-" +
      ("0" + (endDate.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + endDate.getDate()).slice(-2);
  }

  return request({
    method: "GET",
    url: EXCESSIVE_ACTIVITY_API_URL + "/excessive-activity",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { startDate: startDateParam, endDate: endDateParam },
  })
    .then((response: RiskAnalysisResponse) => {
      return response.excessiveActivity;
    })
    .catch((error: string) => {
      throw error;
    });
};

export { sendNotification, getExcessiveActivity };
